export default __webpack_public_path__ + "static/media/coins.260eed48.png";